module.exports = __webpack_public_path__ + "static/media/spotify.69a75a69.png";